import React, { useState, useMemo } from "react";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./editTask.scss";
import Modal from "../modal/modal";
import DatePicker from "react-datepicker";
import deleteUserIcon from "../editUser/delete-user-icon.svg";
import { TimeZone } from "../utils";
import Attachments from "../attachments/attachments";
import Attachment from "../attachment/attachment";
import ApiHandler from "../api";

const TASK_TYPES = [
  "Change wipers",
  "Change flippers",
  "Change batteries",
  "Change site screening",
  "Bearings",
  "Change motors",
  "Cleaning quality checking",
  "Other",
];

const TASK_STATUSES = {
  open: "Open",
  inProgress: "In progress",
  done: "Done",
};

const EditTaskComponent = (props) => {
  const isNewTask = useMemo(
    () => props.task._id === undefined,
    [props.task._id]
  );

  const [state, setState] = useState({
    ...props.task,
    files: [],
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiHandler = useMemo(() => new ApiHandler(), []);

  const onChange = (value, param) => {
    setState((prevState) => ({
      ...prevState,
      [param]: value,
    }));
  };

  const onSubmit = async () => {
    let params = { ...state };
    params.projectId = props.project._id;

    const mandatory = {
      status: "Status",
      dueDate: "Due date",
      taskType: "Task type",
    };

    for (let key in mandatory) {
      if (!params[key])
        return alert(`Please fill in the ${mandatory[key]} field`);
    }

    setIsLoading(true);
    setError(null);

    try {
      if (isNewTask) {
        await apiHandler.createTask(params);
      } else {
        await apiHandler.editTask(params, props.task._id);
      }
      // Success - close modal
      props.closeEditTask();
    } catch (error) {
      console.error("Failed to save task:", error);
      setError(error.message || "Failed to save task");
    } finally {
      setIsLoading(false);
    }
  };

  const onStatusSelected = (item) => {
    setState((prevState) => ({ ...prevState, status: item.value }));
  };

  const getTitle = () => {
    if (isNewTask) return "New Task";
    else return "Edit Task";
  };

  const onTaskTypeChanged = (item) => {
    setState((prevState) => ({ ...prevState, taskType: item.value }));
  };

  const onStatusChanged = (item) => {
    setState((prevState) => ({ ...prevState, status: item.value }));
  };

  const dueDateChanged = (dueDate) => {
    console.log("dueDate", dueDate);
    setState((prevState) => ({ ...prevState, dueDate }));
  };

  const onFilesChanged = (files) => {
    setState((prevState) => ({ ...prevState, files }));
  };

  const closeAttachment = () => {
    setState((prevState) => ({ ...prevState, selectedAttachment: null }));
  };

  return (
    <Modal title={getTitle()} onClose={props.closeEditTask}>
      {error && (
        <div
          className="error-message"
          style={{ color: "red", padding: "10px" }}
        >
          {error}
        </div>
      )}
      {state.selectedAttachment ? (
        <Attachment
          closeAttachment={closeAttachment}
          src={state.selectedAttachment.path}
        />
      ) : null}
      <div className="input-line">
        <div className="input-description">Task Type</div>
        <Dropdown
          options={TASK_TYPES}
          onChange={onTaskTypeChanged}
          placeholder="Select task type"
          value={state.taskType}
          className="dropdown"
          controlClassName="control"
        />
      </div>

      <div className="input-line">
        <div className="input-description">Status</div>
        <Dropdown
          options={Object.entries(TASK_STATUSES).map((item) => ({
            label: item[1],
            value: item[0],
          }))}
          onChange={onStatusChanged}
          placeholder="Select status"
          value={state.status}
          className="dropdown"
          controlClassName="control"
        />
      </div>

      <div className="new-task-lines">
        <div className="input-line">
          <div className="input-description">Due Date</div>
          <div className="date-wrapper">
            <DatePicker
              selected={state.dueDate}
              onChange={dueDateChanged}
              startDate={state.dueDate}
              // dateFormat="Pp"
              // maxDate={new Date()}
              // shouldCloseOnSelect={true}
              customInput={
                <span>
                  {new TimeZone(props.project).getLocalTime(
                    state.dueDate,
                    true
                  )}
                </span>
              }
              // customInput={<this.VoltageDateCustomInput/>}
            />
          </div>
        </div>
      </div>

      <div className="input-line">
        <div className="input-description">Description</div>
        <input
          value={state.description}
          placeholder=""
          type="text"
          onChange={(e) => onChange(e.target.value, "description")}
        />
      </div>

      {!isNewTask && (
        <div className="input-line">
          <Attachments
            type="task"
            projectId={props.project._id}
            taskId={props.task._id}
            attachments={props.task.attachments}
          />
        </div>
      )}

      {isNewTask ? (
        <div className="buttons-wrapper">
          <div className="button" onClick={onSubmit} disabled={isLoading}>
            {isLoading ? "SAVING..." : "SAVE"}
          </div>
        </div>
      ) : (
        <div className="buttons-wrapper">
          {props.deleteTask ? (
            <div className="delete-row" onClick={props.deleteTask}>
              <img src={deleteUserIcon} />
              <span>Delete task</span>
            </div>
          ) : null}
          <div className="button cancel" onClick={props.closeEditTask}>
            CANCEL
          </div>
          <div className="button" onClick={onSubmit} disabled={isLoading}>
            {isLoading ? "SAVING..." : "SAVE"}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default EditTaskComponent;
